/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { Flex, Box, Heading, Hide } from '@qga/roo-ui/components';
import { Offer } from 'types/property';
import OfferInclusions from './OfferInclusions';
import OfferDetailsTooltip from './OfferDetailsTooltip';
import OfferDetailsModal from './OfferDetailsModal';

interface OfferDetailsProps {
  offer: Offer;
}

const OfferDetails: React.FC<OfferDetailsProps> = memo(({ offer }) => {
  const { inclusions, description: offerDescription, name: offerName, valueAdds = [] } = offer;

  return (
    <Flex flexDirection="column" data-testid="offer-details">
      <Heading.h3 display="block" mb={0} fontSize="md" lineHeight="normal">
        {offerName}
      </Heading.h3>
      <Box height="auto" color="greys.charcoal">
        <OfferInclusions inclusions={inclusions} valueAdds={valueAdds} showAllInclusions={true} />
        <Box pt={2}>
          <Hide sm xs>
            <OfferDetailsTooltip offerDescription={offerDescription} offerName={offerName} />
          </Hide>
        </Box>
        <Hide md lg>
          <OfferDetailsModal offerDescription={offerDescription} offerName={offerName} />
        </Hide>
      </Box>
    </Flex>
  );
});

export default OfferDetails;
